
<main>
    <div class="row">
        <div class="col-12 col-md-6" style="text-align: center; margin-bottom: 4px;">
            <button (click)="scanQR()" class="btn-common">Scan QR</button>
        </div>
        <div class="col-12 col-md-6" style="text-align: center; margin-bottom: 4px;">
            <button (click)="GotoInvitation()" class="btn-common">મેન્યુઅલ હાજરી</button>
        </div>
    </div>

    <div class="profile-details">
        <div class="profile-form">
            <form action="">
                <div class="form-group">

                </div>
            </form>
        </div>
    </div>

</main>